import axios from "axios";
import authentication from "@/authentication";

export default {
  baseBaseUrl: process.env.VUE_APP_API_URL_BASE,
  mgmtUrl: process.env.VUE_APP_API_MGMT_BILLING_SERVICE_BASE,
  async checkConnection() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.baseUrl}/CheckOauthConnection`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async searchOrders(query) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.mgmtUrl}/SearchOrders/${query}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        },
        maxContentLength: 99999999
      })
      .then(response => {
        return response.data;
      });
  },
  async removeOrders(orderIds) {
    await authentication.isAuthenticated();
    return axios
      .post(
        `${this.mgmtUrl}/DoNotBillOrders`,
        { orders: orderIds, user: authentication.getUser().userName },
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          }
        }
      )
      .then(response => {
        return response.data;
      });
  },
  async autoApproveOrders(orderIds) {
    await authentication.isAuthenticated();
    return axios
      .post(
        `${this.mgmtUrl}/AutoApproveOrders`,
        { orders: orderIds, user: authentication.getUser().userName },
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          }
        }
      )
      .then(response => {
        return response.data;
      });
  },
  async saveApproval(updatedOrder) {
    updatedOrder.User = authentication.getUser().userName;
    
    await authentication.isAuthenticated();
    return axios
      .post(`${this.mgmtUrl}/SaveAndApprove`, updatedOrder, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  },
  async getNotes(orderId) {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.mgmtUrl}/GetCourierOrderDetails/${orderId}`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        },
        maxContentLength: 99999999
      })
      .then(response => {
        return response.data;
      });
  },
  async getNotesInternal(packageId, type) {
    await authentication.isAuthenticated();
    return axios
      .get(
        `${this.baseBaseUrl}/NotesInternal?packageId=${packageId}&type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          },
          maxContentLength: 99999999
        }
      )
      .then(response => {
        return response.data;
      });
  },
  async createNotesInternal(notesInternal) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.baseBaseUrl}/NotesInternal`, notesInternal, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        },
        maxContentLength: 99999999
      })
      .then(response => {
        return response.data;
      });
  },
  async getPendingOrders() {
    await authentication.isAuthenticated();
    return axios
      .get(`${this.mgmtUrl}/GetPendingCourierOrders`, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        },
        maxContentLength: 99999999
      })
      .then(response => {
        return response.data;
      });
  },
  async flagItem(payload) {
    await authentication.isAuthenticated();
    return axios
      .post(`${this.mgmtUrl}/FlagCourierMove`, payload, {
        headers: {
          Authorization: `Bearer ${authentication.getToken()}`
        }
      })
      .then(response => {
        return response.data;
      });
  }
};
